"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const live_env_1 = require("@ledgerhq/live-env");
const mock_1 = require("../mock");
const helpers_1 = require("../helpers");
const prando_1 = __importDefault(require("prando"));
function btcTrend(date) {
    const daysSinceGenesis = (date.valueOf() - 1230937200000) / (24 * 60 * 60 * 1000);
    return Math.pow(daysSinceGenesis / 693, 5.526);
}
const randomCache = {};
function fromToRandom(id) {
    if (randomCache[id])
        return randomCache[id];
    return (randomCache[id] = new prando_1.default((0, live_env_1.getEnv)("MOCK") + id).next());
}
function temporalFactor(from, to, maybeDate) {
    const date = maybeDate || new Date();
    const r = fromToRandom(from); // make it varies between rates...
    const wave1 = Math.cos(r * 0.5 + date / (200 * 24 * 60 * 60 * 1000 * (0.5 + 0.5 * r)));
    // long term wave
    const wave2 = Math.sin(r + date / (30 * 24 * 60 * 60 * 1000)); // short term wave
    const wave3 = // random market perturbation
     Math.max(0, Math.sin(date / (66 * 24 * 60 * 60 * 1000))) *
        Math.cos(wave2 + Math.cos(r) + date / (3 * 24 * 60 * 60 * 1000 * (1 - 0.1 * r)));
    // This is essentially randomness!
    if (maybeDate && Math.cos(7 * r + date * 0.1) > 0.9 + 0.1 * r) {
        return 0; // intentionally set a GAP into the data
    }
    const res = (0.2 - 0.2 * r * r) * wave1 +
        (0.1 + 0.05 * Math.sin(r)) * wave2 +
        0.05 * wave3 +
        btcTrend(date) / btcTrend(mock_1.referenceSnapshotDate);
    return Math.max(0, res);
}
function rate(from, to, date) {
    if (from === to)
        return 1;
    const asBTC = (0, mock_1.getBTCValues)()[from];
    if (!asBTC)
        return;
    if (to === "BTC") {
        return asBTC * temporalFactor(from, to, date);
    }
    if (to === "USD") {
        return asBTC * mock_1.BTCtoUSD * temporalFactor(from, to, date);
    }
    if (from === "BTC") {
        const r = rate(to, from, date);
        if (!r)
            return;
        return 1 / r;
    }
    const btcTO = rate("BTC", to, date);
    if (btcTO) {
        return asBTC * btcTO * temporalFactor(from, to, date);
    }
}
const increment = {
    daily: 24 * 60 * 60 * 1000,
    hourly: 60 * 60 * 1000,
};
function getDates(granularity, start) {
    const array = [];
    const f = helpers_1.formatPerGranularity[granularity];
    const incr = increment[granularity];
    const initial = new Date(f(start || new Date())).getTime();
    const now = Date.now();
    for (let t = initial; t < now; t += incr) {
        array.push(new Date(t));
    }
    return array;
}
const api = {
    fetchHistorical: (granularity, { from, to, startDate }) => {
        const r = {};
        const f = helpers_1.formatPerGranularity[granularity];
        getDates(granularity, startDate).forEach(date => {
            const v = rate(from.ticker, to.ticker, date);
            if (v) {
                r[f(date)] = v;
            }
        });
        return Promise.resolve(r);
    },
    fetchLatest: pairs => Promise.resolve(pairs.map(({ from, to }) => rate(from.ticker, to.ticker))),
    fetchMarketcapTickers: () => Promise.resolve(Object.keys((0, mock_1.getBTCValues)())),
};
exports.default = api;
//# sourceMappingURL=api.mock.js.map